import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { globalBusyTracker } from "../utils/globalBusyTracker";

/** Top-of-app progress bar while any tracked API / action work is in flight. */
export default function AppBusyIndicator() {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(globalBusyTracker.busy);

  useEffect(() => globalBusyTracker.subscribe((isBusy) => setBusy(isBusy)), []);

  if (!busy) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.modal + 2,
        pointerEvents: "none",
      }}
      aria-live="polite"
      aria-busy="true"
    >
      <LinearProgress color="primary" />
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          top: 6,
          right: 12,
          px: 1,
          py: 0.25,
          borderRadius: 1,
          bgcolor: "background.paper",
          color: "text.secondary",
          boxShadow: 1,
          pointerEvents: "none",
        }}
      >
        {t("common.working")}
      </Typography>
    </Box>
  );
}
